import React from 'react';

import Fields from 'ui/form/FieldsForm';
import { Typography } from '@material-ui/core';

const USERNAME_ACCOUNT = ['msp', 'reseller', 'reseller_msp'];

const isUsernameAccount = (type, accounts = USERNAME_ACCOUNT) =>
    accounts.includes(type);

export default function ContactPart({ values, errors, onChange, integration }) {
    const changeFactory = name => value => onChange(name, value);
    const isUsernameRequired = () => isUsernameAccount(values.type);

    return (
        <React.Fragment>
            <Fields.OneLine>
                <Fields.Text
                    label="First name"
                    error={errors.first_name}
                    value={values.first_name}
                    onChange={changeFactory('first_name')}
                />
                <Fields.Text
                    label="Last name"
                    error={errors.last_name}
                    value={values.last_name}
                    onChange={changeFactory('last_name')}
                />
            </Fields.OneLine>
            <Fields.Text
                label="Email address"
                error={errors.email}
                value={values.email}
                onChange={changeFactory('email')}
                helper={
                    errors.email === 'exists' && 'Email address already exists'
                }
            />
            {isUsernameRequired() && (
                <Fields.Text
                    label="Username"
                    error={errors.username}
                    value={values.username}
                    onChange={changeFactory('username')}
                    helper={
                        errors.username === 'exists' &&
                        'Username already exists'
                    }
                />
            )}
            <Fields.Phone
                label="Phone number (optional)"
                error={errors.phone}
                value={values.phone}
                country={values.country}
                onChange={changeFactory('phone')}
            />
            {integration && (
                <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{ marginBottom: 24 }}
                >
                    Primary contact will receive an email with a temporary
                    password to login to the CyberFOX Password Manager
                    application.
                </Typography>
            )}
        </React.Fragment>
    );
}
